import React, { useEffect, useState } from "react";
import Newsitem from "./Newsitem";
import Spinner from "../Spinner";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";

const Newscomponent = (props) => {
    const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const [article, setArticle] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalresults, setTotalresults] = useState(0);
  
   

  

  const update = async () => {
    props.setProgress(10);
    const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apikey=e4f942023c9748498cb1b25b61633b9a&page=${page}&pageSize=${props.pageSize}`;
    setLoading(true);
    let data = await fetch(url);
    props.setProgress(30);
    let parsedata = await data.json();
    props.setProgress(60);
    setArticle(parsedata.articles);
    setTotalresults(parsedata.totalResults);
    setLoading(false);

    props.setProgress(100);
  };

  useEffect(() => {
    document.title = `${capitalizeFirstLetter(
        props.category
      )} - NewsMonkey`;
    update()
    //eslint-disable-next-line
  }, []);
  

  const fetchMoreData = async () => {
   

    const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apikey=e4f942023c9748498cb1b25b61633b9a&page=${page+1}&pageSize=${props.pageSize}`;
    setPage(page + 1);
    let data = await fetch(url);
    let parsedata = await data.json();
    setArticle(article.concat(parsedata.articles));
    setTotalresults(parsedata.totalResults);
  };

  return (
    <>
    <div style={{marginTop:"120px"}}>
      <h2 className="text-center mt-5 mb-4" style={{marginTop:"70px"}}>
        <strong>{props.heading}</strong>
      </h2>
      </div>
      {loading && <Spinner />}
      <InfiniteScroll
        dataLength={article.length}
        next={fetchMoreData}
        hasMore={article.length !== totalresults}
        loader={<Spinner />}
      >
        <div className="container">
          <div className="row">
            {article.map((element) => {
              return (
                <div className="col-md-4" key={element.url}>
                  <Newsitem
                    title={element.title ? element.title : ""}
                    description={element.description ? element.description : ""}
                    url={element.urlToImage}
                    newsurl={element.url}
                    date={element.publishedAt}
                    author={element.author ? element.author : "Anonymous"}
                    source={element.source.name}
                    color={props.color}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </InfiniteScroll>
    </>
  );
};
Newscomponent.defaultProps = {
  country: "in",
  pageSize: 8,
  category: "general",
  time: "a while Age",
  color: "dark",
};
Newscomponent.propTypes = {
  country: PropTypes.string,
  pageSize: PropTypes.number,
  category: PropTypes.string,
};

export default Newscomponent;
